require '../presenters/bookings'
require '../../../common/frontend/presenters/error'
require './request_response_view'

class Extranet.Views.BookingPopup extends Backbone.View

  selectors:
    content: '.request-response-content'
    loadingIndicator: '.loading-indicator'
    errorMessage: '.error-message'
    requestData: '.request-data'
    responseData: '.response-data'
    showButton: '.show-request-response-btn'

  events:
    'click .show-request-response-btn': '_showRequestResponse'
    'click .close-modal': '_clearRequestResponseData'
    'hidden.bs.modal': '_clearRequestResponseData'

  el: 'body'  # Use body for event delegation since modals are dynamically created

  initialize: (options) ->
    @alertMessage = Extranet.Helper.AlertView.getAlertView()
    @presenter = new Extranet.Presenters.Bookings({collection: null})
    @errorPresenter = new Extranet.Presenters.Error()
    @requestResponseView = new Extranet.Views.RequestResponseView()


  _showRequestResponse: (e) ->
    e.preventDefault()
    button = $(e.currentTarget)
    bookingId = button.data('booking-id')
    hotelUuid = button.data('hotel-uuid')
    checkInDate = button.data('check-in-date')
    checkOutDate = button.data('check-out-date')
    channelManager = button.data('channel-manager')
    inventoryUnitId = button.data('inventory-unit-id')

    @requestResponseView.render(bookingId, hotelUuid, checkInDate, checkOutDate, channelManager, inventoryUnitId)

  _clearRequestResponseData: ->
    @requestResponseView._clearRequestResponseData()

